{
  "botPatterns": [
    "facebookexternalbot",
    "facebookcatalog",
    "twitterbot",
    "linkedinbot",
    "whatsapp",
    "slackbot",
    "telegrambot",
    "discordbot",
    "googlebot",
    "bingbot",
    "applebot",
    "duckduckbot",
    "pinterest",
    "redditbot",
    "skypeuripreview",
    "iframely",
    "embedly",
    "outbrain",
    "rogerbot",
    "semrushbot",
    "ahrefsbot",
    "webexteams"
  ],
  "defaultMeta": {
    "title": "Cisco U. | Learning and Certifications",
    "description": "Cisco U. helps learners discover, track, and complete training and certifications through a unified learning platform.",
    "image": "https://u.cisco.com/CiscoU.png"
  },
  "routeMeta": [
    {
      "match": "exact",
      "path": "/",
      "meta": {
        "title": "Cisco U. | Personalized tech learning for every skill level",
        "description": "Get skills development, certifications, product training, and more straight from Cisco experts."
      }
    },
    {
      "match": "exact",
      "path": "/certifications",
      "meta": {
        "title": "Certifications | Cisco U.",
        "description": "Earn the gold standard in IT certifications and advance your career in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/certifications/",
      "meta": {
        "title": "Certifications | Cisco U.",
        "description": "Prepare for Cisco Certifications with official training, practice exams, and hands-on labs in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/explore",
      "meta": {
        "title": "Explore | Cisco U.",
        "description": "Explore Learning Paths, tutorials, certifications, hands-on labs, practice exams, and more in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/courses",
      "meta": {
        "title": "Explore courses | Cisco U.",
        "description": "Build real-world tech skills with courses in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/labs",
      "meta": {
        "title": "Explore labs | Cisco U.",
        "description": "Engage in hands-on labs to be exam or job ready in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/exams",
      "meta": {
        "title": "Explore practice exams | Cisco U.",
        "description": "Test your cert readiness in an exam-like environment in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/challenges",
      "meta": {
        "title": "Explore challenges | Cisco U.",
        "description": "Capture confidence, problem-solving skills, and badges with challenges in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/events",
      "meta": {
        "title": "Explore events & webinars | Cisco U.",
        "description": "Join Cisco experts to learn top-of-mind topics at the forefront of tech."
      }
    },
    {
      "match": "exact",
      "path": "/instructorled",
      "meta": {
        "title": "Explore instructor-led training | Cisco U.",
        "description": "Get real-time feedback, Q&A, and hands-on practice with a live expert—virtual or in-person."
      }
    },
    {
      "match": "exact",
      "path": "/exam-voucher",
      "meta": {
        "title": "Explore exam vouchers | Cisco U.",
        "description": "Commit to your certification goal with pre-paid exam vouchers in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/bundles",
      "meta": {
        "title": "Explore exam bundles | Cisco U.",
        "description": "Accelerate your path to cert-ready with curated exam bundles in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/paths",
      "meta": {
        "title": "Explore Learning Paths | Cisco U.",
        "description": "Follow structured Learning Paths to achieve your learning goals in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/podcasts",
      "meta": {
        "title": "Explore Podcasts | Cisco U.",
        "description": "Tune into expert conversations on current tech topics in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/tutorials",
      "meta": {
        "title": "Explore Tutorials | Cisco U.",
        "description": "Quickly learn Cisco technologies and tools with short tutorials in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/videos",
      "meta": {
        "title": "Explore Videos | Cisco U.",
        "description": "Watch the latest tech videos in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/courses/",
      "meta": {
        "title": "Courses | Cisco U.",
        "description": "Build real-world tech skills with courses in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/labs/",
      "meta": {
        "title": "Labs | Cisco U.",
        "description": "Engage in hands-on labs to be exam or job ready in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/exams/",
      "meta": {
        "title": "Practice exams | Cisco U.",
        "description": "Test your cert readiness in an exam-like environment in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/exam-voucher/",
      "meta": {
        "title": "Exam vouchers | Cisco U.",
        "description": "Commit to your certification goal with pre-paid exam vouchers in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/content-bundle/",
      "meta": {
        "title": "Exam bundles | Cisco U.",
        "description": "Accelerate your path to cert-ready with curated learning and exam bundles in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/challenges/",
      "meta": {
        "title": "Challenges | Cisco U.",
        "description": "Capture confidence, problem-solving skills, and badges with challenges in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/paths/",
      "meta": {
        "title": "Learning Paths | Cisco U.",
        "description": "Follow structured Learning Paths to skilling success in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/instructor-led/",
      "meta": {
        "title": "Instructor-led training | Cisco U.",
        "description": "Get real-time feedback, Q&A, and hands-on practice with a live expert—virtual or in-person."
      }
    },
    {
      "match": "prefix",
      "path": "/podcast/",
      "meta": {
        "title": "Podcasts| Cisco U.",
        "description": "Tune into expert conversations on current tech topics in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/tutorials/",
      "meta": {
        "title": "Tutorials | Cisco U.",
        "description": "Quickly learn Cisco technologies and tools with short tutorials in Cisco U."
      }
    },
    {
      "match": "prefix",
      "path": "/videos/",
      "meta": {
        "title": "Video series | Cisco U.",
        "description": "Watch your favorite tech video playlists in Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/learn",
      "meta": {
        "title": "Learn | Cisco U.",
        "description": "Learn in-demand skills in AI, networking, cybersecurity, cloud, and more straight from Cisco experts."
      }
    },
    {
      "match": "prefix",
      "path": "/learn/",
      "meta": {
        "title": "Learn | Cisco U.",
        "description": "Learn in-demand skills in AI, networking, cybersecurity, cloud, and more straight from Cisco experts."
      }
    },
    {
      "match": "exact",
      "path": "/communities",
      "meta": {
        "title": "Communities | Cisco U.",
        "description": "Learn and grow with a global network of peers and experts in the Cisco Learning Network."
      }
    },
    {
      "match": "exact",
      "path": "/search",
      "meta": {
        "title": "Search | Cisco U.",
        "description": "Search for skills development, certifications, product training, and more across Cisco U."
      }
    },
    {
      "match": "exact",
      "path": "/store/plans",
      "meta": {
        "title": "Plans | Cisco U.",
        "description": "Unlock access to Learning Paths, courses, labs, and more with a Cisco U. subscription."
      }
    },
    {
      "match": "prefix",
      "path": "/store",
      "meta": {
        "title": "Store | Cisco U.",
        "description": "From individual titles to a subscription, shop the Cisco U. Store to find learning to match any goal."
      }
    },
    {
      "match": "exact",
      "path": "/for-you",
      "meta": {
        "title": "For You | Cisco U.",
        "description": "Select from learning recommendations curated just for you in Cisco U."
      }
    }
  ]
}
